export default {
  props: {
    title: { // 모달 창의 타이틀
      type: String,
      default: '',
      required: false
    },
    visible: { // 모달 창 보이기 여부
      type: Boolean,
      default: true,
      required: false
    },
    height: { // 모달 창의 Height
      type: String,
      default: 'auto',
      required: false
    },
    visibleConfirmButton: { // 확인 버튼 보이기 여부
      type: Boolean,
      default: true,
      required: false
    },
    visibleCancelButton: { // 취소 버튼 보이기 여부
      type: Boolean,
      default: true,
      required: false
    },
    visibleCloseButton: { // 닫기 버튼 보이기 여부
      type: Boolean,
      default: false,
      required: false
    }
  }, // end-props
  created () {
    this.data.visible = this.visible
  },
  mounted () {
  },
  watch: {
    visible () {
      this.data.visible = this.visible
    },
    'data.visible' () {
      this.$emit('update:visible', this.data.visible)
    }
  },
  computed: {
    isVisible () {
      return this.visible
    }
  },
  methods: {
    /**
     * 우 상단의 닫기 아이콘 클릭시 처리
     * 취소버튼이 보여지고 있다면 취소 버튼 클릭과 동일하게 처리하고
     * 취소버튼이 보여지고 있지 않다면 닫기 버튼 클릭과 동일하게 처리된다.
     */
    onClickCloseIcon () {
      if (this.visibleCancelButton) this.onClickCancelButton()
      else this.onClickCloseButton()
    },

    /**
     * 닫기 버튼 클릭시 처리
     * 호출하는 측에서 returnObject.visible을 false로 설정할 경우 모달 창이 닫히지 않는다.
    */
    onClickCloseButton () {
      let returnObject = { visible: undefined }
      this.$emit('click-close-button', returnObject)

      setTimeout(() => {
        // Modal을 사용하는 곳에서 Visible을 결정할 수 있게 함
        this.data.visible = returnObject.visible === undefined ? !this.data.visible : returnObject.visible
      })
    },

    /**
     * 취소 버튼 클릭시 처리
     * 호출하는 측에서 returnObject.visible을 false로 설정할 경우 모달 창이 닫히지 않는다.
    */
    onClickCancelButton () {
      let returnObject = { visible: undefined }
      this.$emit('click-cancel-button', returnObject)

      setTimeout(() => {
        // Modal을 사용하는 곳에서 Visible을 결정할 수 있게 함
        this.data.visible = returnObject.visible === undefined ? !this.data.visible : returnObject.visible
      })
    },

    /**
     * 확인 클릭시 처리
     * 호출하는 측에서 returnObject.visible을 false로 설정할 경우 모달 창이 닫히지 않는다.
    */
    onClickConfirmButton () {
      let returnObject = { visible: undefined }
      this.$emit('click-confirm-button', returnObject)

      setTimeout(() => {
        // Modal을 사용하는 곳에서 Visible을 결정할 수 있게 함
        this.data.visible = returnObject.visible === undefined ? !this.data.visible : returnObject.visible
      })
    }
  }, // end-method
  data () {
    return {
      data: {
        visible: undefined
      }
    }
  }
}
